/**
 * HUB.SMSRoute.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SMPPClientCredentialDto { 
    routeId?: string;
    systemId?: string;
    password?: string;
    dateCreated?: Date;
    agreggatorId?: string;
    serviceProviderEmail?: string;
    serviceProviderName?: string;
    serviceProviderId?: string;
    host?: string;
    port?: string;
}